import { IDatum } from '../types.DrawIt';

export const linearInterpolation = <T extends IDatum>(data: T[], xKey = 'x', yKey = 'y') => {
    return (datum: Partial<IDatum>): number => {
        let point: number | undefined = undefined;
        let points: number[][] | undefined = undefined;

        if (xKey in datum) {
            point = datum[xKey] || 0;
            points = data.sort((a, b) => a[xKey] - b[xKey]).map(i => [i[xKey], i[yKey]]);
        }

        if (yKey in datum) {
            point = datum[yKey] || 0;
            points = data.sort((a, b) => a[yKey] - b[yKey]).map(i => [i[yKey], i[xKey]]);
        }

        if (point && points && points.length >= 2) {
            const n = points.length - 1;

            if (point <= points[0][0]) {
                return (
                    points[0][1] +
                    ((point - points[0][0]) * (points[1][1] - points[0][1])) / (points[1][0] - points[0][0])
                );
            }

            if (point >= points[n][0]) {
                return (
                    points[n][1] +
                    ((point - points[n][0]) * (points[n][1] - points[n - 1][1])) / (points[n][0] - points[n - 1][0])
                );
            }

            for (let i = 0; i < n; i += 1) {
                if (point > points[i][0] && point <= points[i + 1][0]) {
                    return (
                        points[i][1] +
                        ((point - points[i][0]) * (points[i + 1][1] - points[i][1])) / (points[i + 1][0] - points[i][0])
                    );
                }
            }
        }

        throw new Error("Can't calculate linear interpolation");
    };
};
